import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40f61cb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "form-outline mb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "uploadType"
}, "Upload type", -1))
const _hoisted_4 = { class: "form-outline mb-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "uploadName"
}, "Layer name", -1))
const _hoisted_6 = {
  key: 0,
  class: "error-text pt-2"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-center text-info" }, "Files successfully uploaded!", -1))
const _hoisted_10 = [
  _hoisted_9
]

import ModalDialog from "@/components/Modals/ModalDialog.vue";
import VueSelect from "vue-select";
import { reactive, onBeforeUnmount, onMounted, watch } from "vue";
import { Dashboard as VueDashboard } from "@uppy/vue";
import { Constants } from "@/classes/constants";
import Tus from "@uppy/tus";
import { BasePlugin, Uppy } from "@uppy/core";
import XHRUpload from "@uppy/xhr-upload"
import "@uppy/core/dist/style.css"
import "@uppy/dashboard/dist/style.css"
import { Utils } from "@/classes/utils/utils";
import { useDataStore } from "@/store/data-store";
import { computed } from "@vue/reactivity";
import { useAppStateStore } from "@/store/app-state";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFilesDialog',
  props: {
	surveyuuid: {
		type: String,
		required: true
	}
},
  emits: ["onHide", "onComplete"],
  setup(__props, { expose, emit }) {

const props = __props;



let appState = useAppStateStore();

let data = reactive({
	name: null as string,
	show: false,
	isUploadComplete: false,
	selectedUploadType: null as string,
	uploadName: null as string,
	uploadUUID: null as string,
	uploadTypes: [
		"orthophoto",
		"pointcloud",
		"model",
		"cad",
		"video"
	],
	uploadFileTypes: {
		"orthophoto": [".prj", ".pgw", ".png"],
		"pointcloud": [".las", ".laz"],
		"model": [".ply", ".obj", ".mtl", ".jpg", ".jpeg", ".png"],
		"cad": [".dxf"],
		"video": [".mp4", ".avi", ".txt"]
	}
})
let intervalId: number | undefined;

let layerNameError = computed(() => {
	let existingLayerNames = appState.view1Survey.inputFiles.filter((x) => x.type === data.selectedUploadType).map((u) => u.name);
	if (existingLayerNames.includes(data.uploadName)) {
		return "Layer name already exist in survey. Please change it"
	}
});


class SurveyUploadPreprocessor extends BasePlugin {
	constructor(uppy, opts) {
		super(uppy, opts);
		this.id = "SurveyUploadProcessor";
		this.type = "upload-processor";
	}

	prepareUpload = async (fileIDs) => { // ← this!
		console.log("Prepaire upload", fileIDs, this);
		if (!uploadUUID) {
			let dataStore = useDataStore();
			data.uploadUUID = await dataStore.createSurveyUpload(props.surveyuuid, data.uploadName, data.selectedUploadType, uppyClient.getFiles().length);
		}
	}

	install() {
		this.uppy.addPreProcessor(this.prepareUpload)
	}

	uninstall() {
		this.uppy.removePreProcessor(this.prepareUpload)
	}
}



let token = "";
try {
	token = JSON.parse(localStorage.getItem("user")).accessToken;
} catch (e) {
	console.log("Error getting token", e);
}


function show(uploadType?: "orthophoto" | "pointcloud" | "model" | "cad") {
	data.show = true;
	data.selectedUploadType = uploadType;
	data.uploadName = null;
	data.isUploadComplete = false;
}

function cancel() {
	data.show = false;
	data.isUploadComplete = false;
	uppyClient.cancelAll();
	emit("onHide");
}

function onDataChanged() {
	const meta = {
		surveyUUID: props.surveyuuid,
		type: data.selectedUploadType
	}
	console.log("Setting meta data:", meta);
	uppyClient.setMeta(meta);
	uppyClient.setOptions({
		restrictions: {
			allowedFileTypes: data.uploadFileTypes[data.selectedUploadType]
		}
	})
}

function cleanupFilename(filename: string):string{
	return encodeURIComponent(filename);
}

function startInterval() {
    if (!intervalId) {
        intervalId = setInterval(() => {
            const hasProjectsInProcessing = appState.view1Survey?.inputFiles?.some(file => file.status === "processing" || file.status === "waitingforprocessing");
            if (hasProjectsInProcessing) {
                console.log("Refreshing surveys");
                appState.reloadCurrentProject();
            } else {
                console.log("All projects done processing, stopping interval");
                stopInterval();
            }
        }, 5000);
    }
}

function stopInterval() {
    if (intervalId) {
        clearInterval(intervalId);
        intervalId = undefined;
    }
}

let uploadUUID: string | null = null;

const uppyClient = new Uppy({
	logger: console,
	onBeforeFileAdded: (currentFile) => {
		//Set upload name if it is not set yet
		if (!data.uploadName || data.uploadName.trim().length == 0) {
			data.uploadName = currentFile.name.split(".").slice(0, -1).join(".");
		}
		return true;
	},
	onBeforeUpload: () => {
		if (layerNameError.value) {
			return false;
		}
		return true;
	}
});

if (Constants.useTusForFileUploads) {
	//TUS
	uppyClient.use(SurveyUploadPreprocessor, {});
	uppyClient.use(Tus, {
		endpoint: `${Constants.backendUrl}/api/v1/add-survey-files-tus`,
		retryDelays: [0, 1000, 3000, 5000],
		removeFingerprintOnSuccess: true,
		onBeforeRequest: async (req, file) => {
			req.setHeader("filename", cleanupFilename(file.name))
			req.setHeader("uploaduuid", data.uploadUUID);
			req.setHeader("Authorization", `Bearer ${token}`);
		}
	});
} else {
	//XHR upload
	uppyClient.use(XHRUpload, {
		endpoint: `${Constants.backendUrl}/api/v1/add-files-to-survey`,
		timeout: 24 * 60 * 60 * 1000,
		bundle: true,
		formData: true,
		method: "POST",
		fieldName: "files",
		headers: {
			"Authorization": `Bearer ${token}`,
		}
	})
}

watch(data, onDataChanged);

uppyClient.on("complete", async (result) => {
	if(result.failed.length > 0){
		return;
	}
	console.log(
		"Upload complete! We’ve uploaded these files:",
		result.failed,
		result.successful,
	);
	data.selectedUploadType = null;
	data.uploadName = null;
	data.isUploadComplete = true;
	await Utils.delay(3000);
	cancel();
});

onMounted(async () => {
	watch(() => appState.view1Survey?.inputFiles, (newFiles) => {
        const hasProjectsInProcessing = newFiles?.some(file => file.status === "processing" || file.status === "waitingforprocessing");
        if (hasProjectsInProcessing) {
            startInterval();
        } else {
            stopInterval();
        }
    }, { deep: true, immediate: true });
})

onBeforeUnmount(() => {
	stopInterval();
	console.log("Destorying client")
	uppyClient.close();
});


expose({
	show
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalDialog, {
    visible: _unref(data).show,
    title: !_unref(data).isUploadComplete ? 'Upload survey files' : null
  }, {
    default: _withCtx(() => [
      (!_unref(data).isUploadComplete)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_unref(VueSelect), {
                name: "uploadType",
                class: "underlined mb-2",
                clearable: false,
                modelValue: _unref(data).selectedUploadType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).selectedUploadType) = $event)),
                options: _unref(data).uploadTypes
              }, {
                option: _withCtx((option) => [
                  _createTextVNode(_toDisplayString(option.label) + " (" + _toDisplayString(_unref(data).uploadFileTypes[option.label].join(",")) + ") ", 1)
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                name: "uploadName",
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).uploadName) = $event))
              }, null, 512), [
                [_vModelText, _unref(data).uploadName]
              ]),
              (_unref(layerNameError))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(layerNameError)), 1))
                : _createCommentVNode("", true)
            ]),
            (_unref(data).selectedUploadType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_unref(VueDashboard), {
                    class: "mt-4",
                    uppy: _unref(uppyClient),
                    props: { theme: 'dark', disableThumbnailGenerator: true }
                  }, null, 8, ["uppy"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", { class: "button-wrapper" }, [
              _createElementVNode("button", {
                class: "btn-link me-4",
                onClick: cancel
              }, "Cancel")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})